import { ref, reactive, computed, watch, onUnmounted, onMounted, onBeforeUnmount, onActivated, onDeactivated } from "vue";
import type { Ref, ComputedRef } from "vue";
import { findIndex, sortBy, debounce, throttle } from "lodash";

import type { DataTableColumnType, UseVirtualListType } from "../types";

interface TablePropsType {
  data: any[];
  virtualList: boolean;
  rowHeight: number;
  virtualDataLength: number;
  height: number;
  positionScroll: boolean;
  
  fixedVirtual: boolean;
}

export function useVirtualList(
  props: TablePropsType,
  willShowListData: ComputedRef<any[]>,
  tableScrollWrapEl: Ref<HTMLDivElement | null>,
  ctx: any
): UseVirtualListType {
  let isActivated = true;
  const startVirtualIndex = ref<number>(0);
  const startThVirtualColIndex = ref<number>(0);
  const endThVirtualColIndex = ref<number>(0);
  const tableContWidth = ref<number>(0);
  const tableHeaderHeight = ref<number>(0);
  const positionScrollY = ref<number>(0);
  let showBodyDom: any = null;
  let showBodyDomWrap: any = null;
  let lastScrollLeft = -1;
  const isVirtualScroll = computed(() => {
    return props.virtualList && props.rowHeight > 0;
  });

  const virtualScrollRenderData = computed(() => {
    if (!isVirtualScroll.value) return [];

    return willShowListData.value.slice(
      startVirtualIndex.value,
      startVirtualIndex.value + props.virtualDataLength
    );
  });
  let lastCall: any = null;
  const handleScroll = () => {
    if (!isActivated) return;
    if (!isVirtualScroll.value) return;

    const scrollContainer: any = tableScrollWrapEl.value;
    if (!scrollContainer) return;

    if (!showBodyDom) {
      showBodyDom = scrollContainer.querySelector(
        ".fast-table__body__render__tbody"
      );
    }

    // 计算显示区域的起始索引
    let willSetStartIdx = parseInt(
      scrollContainer.scrollTop / props.rowHeight + ""
    );

    // 增加一个冗余区域来避免白屏
    // 比如这里我们设置冗余区域为虚拟数据长度的三分之一
    const buffer = Math.floor(props.virtualDataLength / 3);
    if (willSetStartIdx < buffer) {
      willSetStartIdx = 0;
    } else {
      willSetStartIdx -= buffer; // 留出冗余空间
    }

    if (startVirtualIndex.value !== willSetStartIdx) {
      startVirtualIndex.value = willSetStartIdx;
      const translateY = props.rowHeight * startVirtualIndex.value;
      if (showBodyDom && showBodyDom.style) {
        if(!props.fixedVirtual){
          showBodyDom.style.transform = `translateY(${translateY}px)`;
        }
       
      }
    }

    ctx.emit("virtual-scroll", {
      startVirtualIndex: startVirtualIndex.value,
      endVirtualIndex: startVirtualIndex.value + props.virtualDataLength,
    });
  };

  const onTableWheel = ( ): void => {
    // 没实现还在想
    if (!props.fixedVirtual) return;
    const container = tableScrollWrapEl.value;

    if (container) {
      
 
      let contentShowLength= parseInt((props.height/props.rowHeight)+"")-2
      // Calculate the scroll amount
     
      

 
      // 计算显示区域的起始索引
      let willSetStartIdx = parseInt(
        container.scrollTop / props.rowHeight + ""
      );

 
     
      if (startVirtualIndex.value !== willSetStartIdx) {
        startVirtualIndex.value = willSetStartIdx;
       
      }
      if(startVirtualIndex.value >props.data.length-contentShowLength && props.data.length-contentShowLength>0 ){
        startVirtualIndex.value = props.data.length-contentShowLength;
       
      } 
       

      ctx.emit("virtual-scroll", {
        startVirtualIndex: startVirtualIndex.value,
        endVirtualIndex: startVirtualIndex.value +contentShowLength,
      });
     
 
      
    }
  };

  // 处理函数
  const processScroll = () => {
    if(props.fixedVirtual){
      onTableWheel();
    }else{  
      handleScroll();
    }
   
    lastCall = Date.now();
  };
  const throttledNum = 100;
  const throttledProcessScroll = throttle(processScroll, throttledNum);
  const debouncedEndProcessScroll = debounce(() => {
    // 在最后一次调用后 200 毫秒内执行处理
    if (Date.now() - lastCall >= throttledNum) {
       
      if(props.fixedVirtual){
        onTableWheel();
      }else{  
        handleScroll();
      }
    }
  }, throttledNum);

  const handleScrollAction = () => {
    throttledProcessScroll();
    debouncedEndProcessScroll();
    checkScrollXColFunc();
  };
  function checkScrollXColFunc() {
    if (tableScrollWrapEl.value) {
      if (
        tableScrollWrapEl.value.scrollLeft != lastScrollLeft ||
        endThVirtualColIndex.value == 0
      ) {
        const headerDoms: NodeListOf<Element> | null =
          tableScrollWrapEl.value.querySelectorAll(
            ".fast-table__head__render__th"
          );
        let fixedRightWidth = 0;
        const fixedRightHeaderDoms: NodeListOf<Element> | null =
          tableScrollWrapEl.value.querySelectorAll(
            ".fast-table__head__th__fixed__right"
          );
        if (fixedRightHeaderDoms && fixedRightHeaderDoms.length) {
          for (let i = 0; i < fixedRightHeaderDoms.length; i++) {
            fixedRightWidth +=
              fixedRightHeaderDoms[i].getBoundingClientRect().width;
          }
        }

        if (headerDoms && headerDoms.length) {
          let nowWidthSize = 0;
          let willSetThStartIdx = -1;
          let willSetThEndIdx = -1;
          for (let i = 0; i < headerDoms.length; i++) {
            nowWidthSize += headerDoms[i].getBoundingClientRect().width;
            if (
              willSetThStartIdx < 0 &&
              nowWidthSize > tableScrollWrapEl.value.scrollLeft
            ) {
              willSetThStartIdx = i;
            }

            if (
              willSetThEndIdx < 0 &&
              nowWidthSize >=
                tableScrollWrapEl.value.scrollLeft +
                  tableScrollWrapEl.value.clientWidth -
                  fixedRightWidth
            ) {
              willSetThEndIdx = i;
            }
            if (willSetThStartIdx >= 0 && willSetThEndIdx >= 0) {
              break;
            }
          }
          if (
            willSetThStartIdx != startThVirtualColIndex.value ||
            willSetThEndIdx != endThVirtualColIndex.value
          ) {
            if (willSetThStartIdx >= 0 && willSetThEndIdx < 0) {
              startThVirtualColIndex.value = willSetThStartIdx;
              endThVirtualColIndex.value = headerDoms.length;
            } else {
              startThVirtualColIndex.value = willSetThStartIdx;
              endThVirtualColIndex.value = willSetThEndIdx;
            }
          } else if (willSetThStartIdx >= 0 && willSetThEndIdx < 0) {
            startThVirtualColIndex.value = willSetThStartIdx;
            endThVirtualColIndex.value = headerDoms.length;
          }
        }

        //假如发生横向滚动
        lastScrollLeft = tableScrollWrapEl.value.scrollLeft || 0;
      }
    }
  }
  onMounted(() => {
    if (isVirtualScroll.value) {
      tableScrollWrapEl.value?.addEventListener("scroll", handleScrollAction);
      initTableDomRect();
      checkScrollXColFunc();
      setTimeout(()=>{
        checkScrollXColFunc();
      },500)
    }
  });

  function initTableDomRect() {
    if (tableScrollWrapEl.value) {
      const tableHeaderDom = tableScrollWrapEl.value.querySelector(
        ".fast-table__head__thead>tr"
      );
      if (tableHeaderDom) {
        tableContWidth.value = tableHeaderDom.clientWidth || 0;
        tableHeaderHeight.value = tableHeaderDom.clientHeight || 0;
      }
      if (!showBodyDom) {
        showBodyDom = tableScrollWrapEl.value.querySelector(
          ".fast-table__body__render__tbody"
        );
      }
      if (showBodyDom && showBodyDom.style)
        showBodyDom.style.transform = `translateY(0px)`;
    }
  }
  onBeforeUnmount(() => {
    tableScrollWrapEl.value?.removeEventListener("scroll", handleScrollAction);
  });
  watch(
    () => props.data,
    () => {
      startVirtualIndex.value = 0;
      if (tableScrollWrapEl.value) {
        tableScrollWrapEl.value.scrollTop = 0;
      }
      initTableDomRect();
      checkScrollXColFunc();
      setTimeout(()=>{
        checkScrollXColFunc();
      },500)
      setTimeout(() => {
        handleScroll();
      });
    }
  );
  onActivated(() => {
    isActivated = true;
    handleScroll();
    checkScrollXColFunc();
    setTimeout(()=>{
      checkScrollXColFunc();
    },500)
  });

  // onActivated(() => {
  //   (tableScrollWrapEl.value as any).scrollTop = 0;
  // });
  onDeactivated(() => {
    isActivated = false;
  
  });

  return {
    onTableWheel,
    tableHeaderHeight,
    tableContWidth,
    isVirtualScroll,
    virtualScrollRenderData,
    startVirtualIndex,
    startThVirtualColIndex,
    endThVirtualColIndex,
    checkScrollXColFunc,
    positionScrollY,
  };
}
